import { Component, Input, OnInit } from '@angular/core';
import { Priority } from 'projects/admin/src/app/features/evaluation-tasks/models/TaskDetails';
import { TaskPriorityEnumValues } from 'projects/admin/src/app/features/evaluation-tasks/models/enums/TaskPriorityEnumValues';



@Component({
  selector: 'app-evaluation-task-priority',
  standalone: false,
  templateUrl: './evaluation-task-priority.component.html'
})
export class EvaluationTaskPriorityComponent implements OnInit {

  @Input({ required: true }) priority: Priority;
  priorityEnum = TaskPriorityEnumValues;

  constructor() { }

  ngOnInit() {
  }

}
